// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.empty[data-v-057d6c8e] {\n\tmargin: 30px;\n\tcolor: var(--main-gray-5);\n\tfont-size: 16px;\n\ttext-align:center;\n}\n.target-email[data-v-057d6c8e] {\n\tfont-size: 11px;\n\tcolor: var(--main-gray-5);\n\t-ms-flex-item-align: center;\n\t    align-self: center;\n\tmargin-left: 5px;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
